// extracted by mini-css-extract-plugin
export default {"cookies_notification":"cookies_notification___PiO7e"};